import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2287466501/src/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2287466501/src/src/app/[locale]/layout/handleUrlParams.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2287466501/src/src/app/[locale]/layout/restoreSession.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApolloWrapper"] */ "/codebuild/output/src2287466501/src/src/app/layout/ApolloWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2287466501/src/src/components/Buttons/phoneLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2287466501/src/src/components/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2287466501/src/src/components/Header/navBarBrand.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2287466501/src/src/components/Hotjar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2287466501/src/src/components/MainContent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2287466501/src/src/components/TagCommander/index.tsx");
